import { Injectable } from "@angular/core";
import { SwUpdate, VersionReadyEvent } from "@angular/service-worker";
import { filter } from "rxjs/operators";
import { AppConfirmService } from '../services/app-confirm/app-confirm.service';

@Injectable({
    providedIn: 'root'
  })
export class PromptUpdateService {

    constructor(swUpdate: SwUpdate, confirmService: AppConfirmService) {
        const isEnabled = swUpdate.isEnabled;
        console.log(`PromptUpdateService[SwUpdate=${isEnabled}]`);

        if (isEnabled) {

            swUpdate.versionUpdates
                 .subscribe(evt=>{
                        switch (evt.type) {
                          case 'VERSION_DETECTED':
                            console.log(`Downloading new app version: ${evt.version.hash}`);
                            break;
                          case 'VERSION_READY':
                            console.log(`Current app version: ${evt.currentVersion.hash}`);
                            console.log(`New app version ready for use: ${evt.latestVersion.hash}`);
                            // confirmService.confirm({ message: `Uma nova versão encontrada! Recarregar a tela?\n(salve qualquer modificação antes).` })
                            // .subscribe(res => {
                            //     if (res) {
                            //         document.location.reload();
                            //     }
                            // });
                            break;
                          case 'VERSION_INSTALLATION_FAILED':
                            console.log(`Failed to install app version '${evt.version.hash}': ${evt.error}`);
                            break;
                        }
                 });   
        }

    }

}